/**
 * iKRDiagram API Service
 */

import { createAppApi } from '../shared';
import type { APIPayload, APIResponse } from './appConfig';
import type { ParsedValues } from './validation';

// ============================================================================
// PAYLOAD MAPPING
// ============================================================================

export function mapInputToPayload(input: ParsedValues): APIPayload {
  return {
    title: input.title,
    L: input.length,
    Lo: input.length_o,
    W: input.width,
    Weight: input.weight,
    KLM: input.klmFactor,
    Ru: input.resistance,
    Xe: input.deflection,
    Ductility: input.ductility,
    Rotation: input.rotation,
    LoadType: input.loadType,
    Pa: input.pressure,
    Ia: input.impulse
  };
}

const { analyze, analyzeCancellable } = createAppApi<ParsedValues, APIPayload, APIResponse>('/post_KRDiagram/', mapInputToPayload, {
  retry: 2,
  timeout: 30000
});

export { analyze, analyzeCancellable };
